import React from 'react';
import Header from './Header';
import Footer from './Footer';

/**
 * تخطيط مشترك لصفحات السياسات والمعلومات (الخصوصية، الشروط، الإرجاع، الدفع، الشحن).
 */
const LegalPageLayout = ({
  title,
  icon,
  lastUpdated,
  totalItems,
  totalFavorites,
  setCurrentPage,
  children
}) => {
  return (
    <div className="min-h-screen bg-gray-50 font-['Cairo']">
      <Header totalItems={totalItems} totalFavorites={totalFavorites} setCurrentPage={setCurrentPage} />

      {/* بانر الصفحة */}
      <div className="border-b bg-white">
        <div className="container mx-auto px-4 py-10">
          <div className="flex items-center gap-5">
            <div className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-2xl bg-[#10B981]/10 text-[#10B981]">
              {icon}
            </div>
            <div>
              <h1 className="mb-1.5 text-3xl font-bold text-gray-900 lg:text-4xl">{title}</h1>
              {lastUpdated && <p className="text-sm text-gray-500">آخر تحديث: {lastUpdated}</p>}
            </div>
          </div>
        </div>
      </div>

      {/* محتوى الصفحة */}
      <div className="container mx-auto px-4 py-12">
        <div className="mx-auto max-w-3xl rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-100 lg:p-10">
          {children}
        </div>
      </div>

      <Footer setCurrentPage={setCurrentPage} />
    </div>
  );
};

/** عنصر فقرة قسم موحّد لاستخدامه داخل صفحات السياسات */
export const LegalSection = ({ title, children }) => (
  <div className="mb-8 last:mb-0">
    <h2 className="mb-3 text-xl font-bold text-gray-900">{title}</h2>
    <div className="space-y-3 leading-relaxed text-gray-600">{children}</div>
  </div>
);

export default LegalPageLayout;
